import {TDeviceInfo} from "./type";

function extractOSVersion(ua: string, os: string): string | undefined {
  switch (os) {
    case "Windows": {
      // Windows NT 10.0; Win64; x64
      return ua.match(/Windows NT ([\d.]+)/)?.[1];
    }
    case "macOS": {
      // Mac OS X 10_15_7
      return ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }
    case "Android": {
      // Android 13; Pixel 6
      return ua.match(/Android ([\d.]+)/)?.[1];
    }
    case "iOS": {
      // iPhone OS 17_0 like Mac OS X
      return ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }
    default:
      return undefined;
  }
}

export function getDeviceInfo(): TDeviceInfo {
  const ua = navigator.userAgent;

  const osMatch = ua.match(/(Windows NT|Mac OS X|Android|iPhone OS|iPad.*OS)/);
  const os = osMatch?.[0]?.includes("Windows")
    ? "Windows"
    : osMatch?.[0]?.includes("Mac")
    ? "macOS"
    : osMatch?.[0]?.includes("Android")
    ? "Android"
    : /iPhone|iPad/.test(ua)
    ? "iOS"
    : "Unknown";

  const os_version = extractOSVersion(ua, os);
  const browserMatch = ua.match(/(Chrome|Firefox|Safari|Edg|Edge)\/([\d.]+)/);
  const deviceMatch = ua.match(/Mobile|Android|iPhone|iPad/) ? "Mobile" : "Desktop";
  const modelMatch = ua.match(/Android.*;\s*(.+?)\s*Build/)?.[1];

  // console.log({
  //   os,
  //   os_version: os_version || "Unknown",
  //   browser: browserMatch?.[1] ?? "Unknown",
  //   browser_version: browserMatch?.[2] ?? "Unknown",
  //   device: deviceMatch,
  //   device_model:
  //     modelMatch || (/iPhone/.test(ua) ? "iPhone" : /iPad/.test(ua) ? "iPad" : undefined),
  // });

  return {
    os,
    os_version: os_version || "Unknown",
    browser: browserMatch?.[1] ?? "Unknown",
    browser_version: browserMatch?.[2] ?? "Unknown",
    device: deviceMatch,
    device_model:
      modelMatch || (/iPhone/.test(ua) ? "iPhone" : /iPad/.test(ua) ? "iPad" : undefined),
  };
}
